module FieldOfficePicker {
  let stateSelect: JQuery<HTMLElement>;
  let citySelect: JQuery<HTMLElement>;
  let officesSelect: JQuery<HTMLElement>;

  export function construct() {
    stateSelect = $("#FieldOfficeStateSelect");
    citySelect = $("#FieldOfficeCitySelect");
    officesSelect = $("#FieldOfficesSelect");

    stateSelect.change(stateSelectChanged);
    citySelect.change(citySelectChanged);

    if (stateSelect.length > 0) {
      stateSelectChanged();
    }
  }

  function stateSelectChanged() {
    clearOfficeCitySelect();
    clearOfficeSelect();
    SelectTools.addBlankOption(citySelect);

    const state = selectedState();
    FieldOfficeFactory.GetCitiesByState(state,
      (cities: string[]) => {
        $.each(cities, (index, city) => {
          citySelect.append(`<option>${city}</option>`);
        });
      },
      () => {
        Notifications.Warning(`Failed to retrieve list of cities with Field Offices for the state ${state}.`);
      }
    );
  }

  function citySelectChanged() {
    clearOfficeSelect();
    SelectTools.addBlankOption(officesSelect);

    const state = selectedState();
    const city = selectedCity();
    FieldOfficeFactory.GetFieldOfficesByStateCity(state, city,
      (fieldOffices) => {
        $.each(fieldOffices, (index, fieldOffice) => {
          officesSelect.append(`<option value="${fieldOffice.RowID}">${fieldOffice.Address}</option>`);
        });
      },
      () => {
        Notifications.Warning(`Failed to retrieve list of Field Offices for ${city}, ${state}.`);
      }
    );
  }

  const selectedState = () => stateSelect.val() as States;
  const selectedCity = () => citySelect.val() as string;

  const clearOfficeCitySelect = () => citySelect.html("");
  const clearOfficeSelect = () => officesSelect.html("");
}